import {Tr} from "@/i18n/i18n";
import {ShopRankDto} from "@/store/shop/types";
import {Keys} from "@/constants/key";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {SquareButton} from "@/scenes.ui/square-button";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import GameObject = Phaser.GameObjects.GameObject;

export class ShopRankPanel extends Phaser.GameObjects.Container {

    public static HEIGHT = 180;

    constructor(scene: Phaser.Scene, x: number, y: number, r: ShopRankDto, callback: () => void) {
        super(scene);

        this.scene = scene;
        this.x = x;
        this.y = y;
        this.width = CU.CANVAS_WIDTH;
        this.height = ShopRankPanel.HEIGHT;

        const back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK, 1, this.height/ShopRankPanel.HEIGHT).setOrigin(0, 0);

        let dx = 0;
        let gameObjects: GameObject[] = [];

        let creature = r.creature;


        let creaturePanel = new CreaturePanel(scene, 70 + dx, 82, creature, () => {}, false);
        creaturePanel.setHealthVisible();

        const titleLight = SpriteUtils.addImage(this.scene, 140, 15 + this.getTitleShift(), Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_LIGHT)
            .setOrigin(0, 0);
        SpriteUtils.setDispSize(titleLight, 360 / 11.5 * CU.S, 65 * CU.S);

        let titleText = TextUtils.addTextAdvanced(scene, r.name, 140, 50 + this.getTitleShift(),
            '#eec761', 22, 'normal', 400, 'left', 2, Fonts.BENGALY_NORMAL);
        titleText.setStroke('#000000', 1);

        let desc = TextUtils.addTextAdvanced(scene, r.description, 141, titleText.y / CU.S + 20,
            '#ababab', 12, 'normal', 280, 'left', 2, Fonts.MYRIADPRO_REGULAR);
        desc.setOrigin(0, 0);

        gameObjects.push(creaturePanel, titleLight, titleText, desc);

        const separator = SpriteUtils.addSprite(this.scene!, 0, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0, 1);

        this.add([back, ...gameObjects, separator]);

        let buyButton = this.createBuyButton();

        if (buyButton) {
            buyButton.setCallback(() => {
                callback();
            });
            this.add(buyButton);
        }

        if (this.showPricesPrices()) {
            let buyPriceText;
            let buyTextY = 118;
            buyPriceText = TextUtils.addText(scene,
                this.getPriceText(r), 515, buyTextY, '#ffffff', this.getPriceTextNoDiscount(), 'bold', 200);
            this.add(buyPriceText);
        }
    }

    protected getDescFontSize(): number {
        return 12;
    }

    protected getPriceTextDiscount(): number {
        return 19;
    }

    protected getPriceTextNoDiscount(): number {
        return 18;
    }

    protected getPriceText(sc: ShopRankDto): string {
        return TextUtils.formatGems(sc.price);
    }

    protected createBuyButton(): any {
        return SpriteUtils.scale(new SquareButton(this.scene, 515, 85, 0, Keys.UI_ART_GREEN_BUTTON,
            this.getBtnIcAtlas(), this.getBtnIcImg(), this.getButtonText(), false), 0.8 / CU.S);
    }

    protected showPricesPrices(): boolean {
        return true;
    }

    protected getTitleShift(): number {
        return 0;
    }

    protected getDescriptionShift(): number {
        return 25;
    }

    protected getBtnIcAtlas(): string | undefined {
        return undefined;
    }

    protected getBtnIcImg(): string {
        return Keys.IC_100_CAVIAR;
    }

    protected getButtonText(): string {
        return Tr('kupit');
    }
}
